/* Ritual buy box: blend + plan, straight to Shopify checkout. */
(function () {
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
    var parse = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };
    var norm = function (v) { return String(v || '').trim().toLowerCase(); };
    var path = function (u) { return String(u || '').split('?')[0].replace(/_\d+x\d*(?=\.)/, ''); };
    var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    var cfg = parse($('[data-ritual-config]')) || {};
    var moneyFormat = cfg.moneyFormat || '£{' + '{amount}}';
    function money(cents) {
      var n = (Number(cents) || 0) / 100;
      var dec = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
        .replace(/\{\{\s*amount\s*\}\}/, dec)
        .replace(/<[^>]*>/g, '');
    }
    function fill(tpl, map) { var out = String(tpl || ''); Object.keys(map).forEach(function (k) { out = out.split('{' + k + '}').join(map[k]); }); return out; }

    var blends = {}, plans = {}, planOrder = [];
    $$('[data-blend-data]').forEach(function (s) { var d = parse(s); if (d) blends[d.id] = d; });
    $$('[data-plan-data]').forEach(function (s) { var d = parse(s); if (d) { plans[d.id] = d; planOrder.push(d.id); } });
    var imageTexts = {};
    (parse($('[data-image-texts]')) || []).forEach(function (t) { if (t && t.src) imageTexts[path(t.src)] = t; });
    function setText(im) {
      var b = blends[state.blend] || {};
      var o = (im && imageTexts[path(im.src)]) || {};
      $('[data-taste-label]').textContent = o.taste || b.taste || '';
      $('[data-taste-notes]').textContent = o.notes || b.notes || '';
      $('[data-stage-note]').textContent = o.stageNote || b.stageNote || '';
    }

    var cb = $('input[name=rt-blend]:checked'), cp = $('input[name=rt-plan]:checked');
    var state = { blend: cb ? cb.value : Object.keys(blends)[0], plan: cp ? cp.value : null };

    function alloc(blend, plan) {
      if (!blend || !plan) return null;
      var n = norm(plan.name);
      return (blend.plans || []).find(function (a) { return norm(a.name) === n; }) || null;
    }

    var img = $('[data-product-image]'), thumbs = $('[data-thumbs]'), addBtn = $('[data-add]'), errorEl = $('[data-error]');
    var onetimeEl = $('[data-onetime]'), onetimeBtn = $('[data-onetime-add]');

    function setMain(src) {
      if (!img || !src) return;
      img.dataset.want = src;
      if (img.getAttribute('src') === src) { img.classList.remove('is-swapping'); return; }
      img.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () { if (img.dataset.want !== src) return; img.src = src; img.classList.remove('is-swapping'); };
      pre.src = src;
    }
    function renderThumbs(list) {
      if (!thumbs) return;
      thumbs.innerHTML = list.map(function (im, i) {
        return '<button type="button" class="' + (i === 0 ? 'is-active' : '') + '" data-thumb="' + i + '" data-src="' + esc(im.src) + '" aria-label="Show image ' + (i + 1) + '"><img src="' + esc(im.thumb) + '" alt="" width="54" height="54" loading="lazy"></button>';
      }).join('');
      thumbs.hidden = list.length < 2;
      $$('[data-thumb]', thumbs).forEach(function (b) {
        b.addEventListener('click', function () {
          $$('[data-thumb]', thumbs).forEach(function (x) { x.classList.toggle('is-active', x === b); });
          setMain(list[Number(b.dataset.thumb)].src);
          setText(list[Number(b.dataset.thumb)]);
        });
      });
    }

    function sync() {
      var b = blends[state.blend];
      if (!b) return;
      $('[data-product-title]').textContent = b.title || '';
      $('[data-product-description]').textContent = b.description || '';
      $('[data-product-tag]').textContent = b.tag || '';
      $('[data-taste-label]').textContent = b.taste || '';
      $('[data-taste-notes]').textContent = b.notes || '';
      $('[data-stage-note]').textContent = b.stageNote || '';
      $('[data-legend-note]').textContent = b.planNote || '';
      if (img) img.alt = b.title || '';

      var servings = Number(b.servings) || 30;
      var visible = [];
      $$('[data-plan-card]').forEach(function (card) {
        var plan = plans[card.dataset.planCard];
        var a = alloc(b, plan);
        card.hidden = !a;
        if (!a) return;
        visible.push(plan.id);
        var div = Number(plan.divisor) > 0 ? Number(plan.divisor) : 1;
        $('[data-plan-detail]', card).textContent = fill(cfg.planDetailText, { price: money(a.price), period: plan.period, cup: money(Math.round(a.price / div / servings)) });
        $('[data-plan-per]', card).innerHTML = esc(money(Math.round(a.price / div))) + '<small>' + esc(plan.perLabel) + '</small>';
      });

      if (visible.indexOf(state.plan) === -1) {
        state.plan = visible.find(function (id) { return plans[id].isDefault; }) || visible[0] || null;
      }
      $$('input[name=rt-plan]').forEach(function (i) { i.checked = i.value === state.plan; });

      var p = plans[state.plan], a = alloc(b, p);
      if (a) {
        var price = money(a.price);
        var wasDiv = Number(p.divisor) > 0 ? Number(p.divisor) : 1, was = (Number(b.basePrice) || 0) * wasDiv;
        $('[data-billing-today]').innerHTML = (was > a.price ? '<s class="rt-was">' + esc(money(was)) + '</s> ' : '') + esc(fill(cfg.todayText, { price: price }));
        $('[data-billing-renewal]').textContent = fill(p.renewal, { price: price, period: p.period });
        addBtn.innerHTML = esc(fill(cfg.buttonText, { price: price })) + ' <span>→</span>';
        addBtn.disabled = false;
      } else {
        addBtn.disabled = true;
      }

      if (onetimeEl) {
        onetimeEl.hidden = !b.oneTime;
        if (b.oneTime) onetimeBtn.textContent = fill(cfg.onetimeLink, { price: money(b.oneTime.price) });
      }

      var kit = (p && b.kits && b.kits[p.slot]) || null;
      var bagPath = b.bag ? path(b.bag.src) : null;
      var rest = (b.images || []).filter(function (im) { return !bagPath || path(im.src) !== bagPath; });
      var list = (kit ? [kit] : []).concat(b.bag ? [b.bag] : []).concat(rest);
      if (list.length) setMain(list[0].src);
      renderThumbs(list);
      setText(list[0]);
    }

    function selectBlend(id) { if (!blends[id]) return; state.blend = id; var i = $('input[name=rt-blend][value="' + id + '"]'); if (i) i.checked = true; sync(); }

    $$('input[name=rt-blend]').forEach(function (x) { x.addEventListener('change', function () { selectBlend(x.value); }); });
    $$('input[name=rt-plan]').forEach(function (x) { x.addEventListener('change', function () { state.plan = x.value; sync(); }); });

    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
        .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || d.message || 'Cart error'); return d; }); });
    }

    addBtn.addEventListener('click', function () {
      var b = blends[state.blend], p = plans[state.plan], a = alloc(b, p);
      if (!a) return;
      addBtn.disabled = true;
      errorEl.hidden = true;
      document.body.classList.add('disabled-recharge-cart-drawer');
      /* Same cart shape as the original nw-featured-product-v3 buy box: subscription line and
         welcome kit lines added together, linked by _bundle_id, then the welcome kit validator runs. */
      var NW = window.NWWelcomeKitCart || {};
      var bundleId = (NW.createBundleId && NW.createBundleId()) || ('nw-' + Date.now());
      var subLine = { id: Number(b.variantId), quantity: 1, selling_plan: Number(a.id), properties: { _bundle_id: bundleId, _line_type: NW.LINE_TYPE_SUBSCRIPTION || 'subscription' } };
      var kitLines = (p.gifts || []).filter(function (g) { return g && g.variantId; }).map(function (g) {
        return { id: Number(g.variantId), quantity: Number(g.quantity) || 1, properties: { _bundle_id: bundleId, _line_type: NW.LINE_TYPE_WELCOME_KIT || 'welcome_kit' } };
      });
      post('/cart/clear.js')
        .then(function () {
          return post('/cart/add.js', { items: [subLine].concat(kitLines) }).catch(function (err) {
            if (!kitLines.length) throw err;
            /* A gift product is unavailable: still sell the subscription rather than block checkout. */
            console.warn('[ritual] welcome kit not added', err);
            return post('/cart/add.js', { items: [subLine] });
          });
        })
        .then(function () { return NW.validate ? NW.validate() : null; })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          console.error('[ritual]', err);
          document.body.classList.remove('disabled-recharge-cart-drawer');
          errorEl.hidden = false;
          addBtn.disabled = false;
        });
    });

    /* One-time purchase: add to the existing cart (no clearing, no welcome kit) and open the cart drawer */
    if (onetimeBtn) onetimeBtn.addEventListener('click', function () {
      var b = blends[state.blend];
      if (!b || !b.oneTime) return;
      onetimeBtn.disabled = true;
      errorEl.hidden = true;
      var ids = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (c) { return c.dataset.sectionId; }).filter(Boolean);
      var body = { items: [{ id: Number(b.oneTime.variantId), quantity: 1 }] };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = window.location.pathname; }
      post('/cart/add.js', body)
        .then(function (added) {
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ritual-onetime', data: { source: 'ritual-onetime', itemCount: cart.item_count, sections: added.sections || {} } } }));
            /* The store's cart drawer is Recharge's: it opens itself on add to cart. Fall back to the theme drawer, then the cart page. */
            if (document.getElementById('recharge-storefront-experiences__cart-drawer')) return;
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') drawer.open(); else window.location.href = '/cart';
          });
        })
        .catch(function (err) { console.error('[ritual] one-time add', err); errorEl.hidden = false; })
        .then(function () { onetimeBtn.disabled = false; });
    });

    /* Links from other sections (#nw-featured-product, "Start with Athletic" buttons) */
    function scrollToBox() {
      var mobile = window.matchMedia('(max-width: 700px)').matches;
      var target = mobile ? (root.querySelector('.rt-purchase') || root.querySelector('.rt-shop')) : root.querySelector('.rt-shop');
      var hh = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 80;
      var top = target.getBoundingClientRect().top + window.pageYOffset - hh - (mobile ? 12 : 0);
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="#nw-featured-product"], a[href$="#shop"]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) !== '#' && href.indexOf(window.location.pathname + '#') === -1) return;
      e.preventDefault();
      e.stopPropagation();
      var want = a.getAttribute('data-rt-product');
      if (want) { var mk = Object.keys(blends).find(function (k) { return String(blends[k].productId) === String(want); }); if (mk) selectBlend(mk); }
      if (a.hasAttribute('data-product-swatch-trigger')) {
        var holder = a.closest('[data-swatch-item][data-product-id]');
        if (!holder) { var sec = a.closest('.shopify-section'); holder = sec && sec.querySelector('[data-swatch-item].active[data-product-id]'); }
        var pid = holder && holder.getAttribute('data-product-id');
        if (pid) { var m = Object.keys(blends).find(function (k) { return String(blends[k].productId) === String(pid); }); if (m) selectBlend(m); }
      }
      scrollToBox();
    }, true);

    sync();
  }

  function boot() { document.querySelectorAll('[data-ritual-shop]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-ritual-shop]'); if (r) { delete r.dataset.ready; init(r); } });
})();
